module.exports = __webpack_public_path__ + "media/anesthesiac.3bacf037.mp3";